import { configureStore } from "@reduxjs/toolkit";
import authSlice from "./slices/authSlice";
import dashboardSlice from "./slices/dashboardSlice";
import userSlice from "./slices/userSlice";
import trainerSlice from "./slices/trainerSlice";
import categorySlice from "./slices/categorySlice";
import courseSlice from "./slices/courseSlice";
import testSlice from "./slices/testSlice";
import discountSlice from "./slices/discountSlice";
import corporateProfileSlice from "./slices/corporateProfileSlice";
import subadminSlice from "./slices/subadminSlice";
import communityForum from "./slices/communityForum";
import languageSlice from "./slices/languageSlice";
import blogSlice from "./slices/blogSlice";
import animatedVideoSlice from "./slices/animatedVideoSlice";
import cmsSlice from "./slices/cmsSlice";
import chatSlice from "./slices/chatSlice";
import notificationSlice from "./slices/notificationSlice";
import complaintFeedbackSlice from "./slices/complaintFeedbackSlice";
import reportSlice from "./slices/reportSlice";

export const store = configureStore({
  reducer: {
    auth: authSlice,
    dashboard: dashboardSlice,
    users: userSlice,
    trainers: trainerSlice,
    category: categorySlice,
    course: courseSlice,
    test:testSlice,
    discount:discountSlice,
    corporateProfile:corporateProfileSlice,
    subadmin:subadminSlice,
    communityForum:communityForum,
    blogs:blogSlice,
    language:languageSlice,
    animatedVideo:animatedVideoSlice,
    cms:cmsSlice,
    chat: chatSlice,
    notification: notificationSlice,
    complaintFeedback: complaintFeedbackSlice,
    report: reportSlice
  },
  devTools: process.env.NODE_ENV === 'development',
});
